import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { EmbedPopupComponent } from '../embed/embed-popup.component';
import { openDialog, closeDialog } from '../common/dialogs/dialogs.actions';
import { Config } from '../universal-config';
const { version: appVersion } = require('../../../package.json');

@Injectable()
export class SocialService {

  constructor(
    public _store: Store<IAppState>,
    public _config: Config,
  ) { }

  openEmbedDialog() {
    const dialogOptions = {
      component: EmbedPopupComponent,
      title: 'Embed code',
      okButtonText: 'Done',
      onSuccess: () => {
        this._store.dispatch(closeDialog());
      }
    }
    this._store.dispatch(openDialog(dialogOptions));
  }

  openPrintDialog(isFolder) {
    if(isFolder) {
      window.print();
    } else {
      const noteTextEditor = window.document.querySelector('.editor-body') || window.document.querySelector('.note-text-holder');

      const noteTextTitle = window.document.querySelector('h1.note-title')
          || window.document.querySelector('.nns-embed-title')
          || window.document.querySelector('.nns-video-header_title');

      if (noteTextEditor && noteTextTitle) {
        const printContents = noteTextEditor.innerHTML;
        const titleContents = noteTextTitle.innerHTML;
        const styleSrc = `${this._config.get('PUBLIC_PATH')}dist/index.css?v=${appVersion}`
        const onLoadFunction = `window.print()`;
        const htmlContents =
        `
        <!DOCTYPE html>
        <html lang="en">
          <head>
            <title>${ titleContents }</title>
            <link rel="stylesheet" href="${styleSrc}">
            <style>
              html {
                font-family: -apple-system,
                BlinkMacSystemFont,
                'Segoe UI',
                Roboto,
                Oxygen-Sans,
                Ubuntu,
                Cantarell,
                'Helvetica Neue',
                sans-serif,
                'Apple Color Emoji',
                'Segoe UI Emoji',
                'Segoe UI Symbol';
              }
              h2 { margin-bottom: 10px; }
              .nedit-root { padding-top: 10px; min-height: auto; }
              .block-menu-container,
              .embedded-menu-container,
              #mentions-search-container { display: none; }
              .inline-tinymce img { width: 100%; }
            </style>
          </head>
          <body onload="${ onLoadFunction }" class="theme-light">
            <h2>${ titleContents }</h2>
            ${ printContents }
          </body>
        </html>
        `;

        const popupWin = window.open('', '_blank', 'width=600,height=600')
        popupWin.document.open()
        popupWin.document.write(htmlContents)
        popupWin.document.close()
      }
    }
  }
}
